import { mergeById, unionById } from '../../../../../shared/utils/array';
import * as sharedActions from '../../../../../shared/store/collections/actions';

const collectionsReducer =
    () =>
    (state = [], action = {}) => {
        const { type, data } = action;

        switch (type) {
            case sharedActions.COLLECTIONS_ACTIONS.UPDATE:
                return mergeById(state, data.collection);
            case sharedActions.COLLECTIONS_ACTIONS.SET_ALL:
                return unionById(state, data.collections);
            default:
                return state;
        }
    };

export default collectionsReducer;
